import { State } from '../../reducers/rootReducer'

const languageIsLoadedSelector = (state: State): boolean => state.languageIsLoaded

export default languageIsLoadedSelector
